// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1ek2V","paramInput":"JobSimulator_paramInput__LMT-w","input":"JobSimulator_input__3QQXt"};